import './components/review/init-review-component';
import { initProductSlider } from './modules/sliders/product-slider';
import { initCoffeeSetsCollapse } from './modules/product-page';

document.addEventListener('DOMContentLoaded', () => {
    function stringWidth(text) {
        const o = $('<div></div>')
            .text(text)
            // eslint-disable-next-line quote-props
            .css({
                // eslint-disable-next-line quote-props
                'position': 'absolute',
                // eslint-disable-next-line quote-props
                'float': 'left',
                'white-space': 'nowrap',
                // eslint-disable-next-line quote-props
                'visibility': 'hidden',
            })
            .appendTo($('body'));
        const w = o.width();
        o.remove();
        return w;
    }

    function hideBtn(el) {
        const btn = $(el).find('.product-page-recipe__expand');

        if (!window.matchMedia('(max-width: 576px)').matches) {
            const maxLineCount = 3;
            const containerWidth = $(el).width() || 552;
            const textWidth = stringWidth($(el).find('.product-page-recipe__text').text());
            const lineCount = Math.round(textWidth / containerWidth);

            if (lineCount < maxLineCount) {
                btn.hide();
            }
        } else {
            btn.css('display', '');
        }
    }

    function collapseRecipe(el) {
        const btn = $(el).find('.product-page-recipe__expand');
        const textContainer = $(el).find('.product-page-recipe__text');
        const textHeight = $(textContainer).find('.product-page-recipe__text-unformatted').height();
        const swiperContainer = btn.closest('.swiper-wrapper');

        if (textContainer.hasClass('opened')) {
            textContainer.removeClass('opened');
            btn.text('Развернуть');
            textContainer.height('');
        } else {
            textContainer.addClass('opened');
            btn.text('Свернуть');
            swiperContainer.addClass('h-auto');
            textContainer.height(textHeight);
        }
    }

    function tooltipPlacement() {
        const tooltip = $('.taste-rating--scaa [data-toggle="tooltip"]');

        if (window.matchMedia('(max-width: 576px)').matches) {
            tooltip.tooltip({
                placement: 'left',
            });
        } else {
            tooltip.tooltip({
                placement: 'top',
            });
        }
    }

    $('.product-page-recipe').each((i, el) => {
        const title = $(el).find('.product-page-recipe__title');
        const btn = $(el).find('.product-page-recipe__expand');

        hideBtn(el);

        title.on('click', () => {
            if (window.matchMedia('(max-width: 576px)').matches) {
                collapseRecipe(el);
            }
        });

        btn.on('click', () => {
            collapseRecipe(el);
        });
    });

    $(window).on('resize', () => {
        $('.product-page-recipe').each((i, el) => {
            hideBtn(el);
        });
    });

    $('.js-props-link').on('click', (e) => {
        e.preventDefault();
        const tabs = $('#prop-tabs');
        const tabId = $('[data-char]').data('slide-id');
        if ($(`[href="#${tabId}"]`).length) {
            $(`#prop-tabs [href="#${tabId}"]`).click();
        }
        $('html, body').animate({
            scrollTop: $(tabs).offset().top,
        }, 1000);
    });

    if (window.matchMedia('(max-width: 576px)').matches) {
        $(`#prop-tabs a[href="#${$('[data-char]').data('slide-id')}"]`).click();
    }

    initProductSlider();
    tooltipPlacement();
    initCoffeeSetsCollapse();
});
